import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGrafanaFaro } from '@/hooks/useGrafanaFaro';

/**
 * Компонент для автоматического отслеживания роутинга в Grafana Faro
 * Аналог YandexMetrikaTracker, но для Faro
 *
 * Размещается внутри Routes, но вне Route components
 *
 * @example
 * <GrafanaFaroTracker />
 */
export const GrafanaFaroTracker = () => {
  const location = useLocation();
  const { trackPageView } = useGrafanaFaro();

  useEffect(() => {
    // Отправляем событие при изменении маршрута
    trackPageView(location.pathname, {
      search: location.search,
      hash: location.hash,
      title: document.title,
    });
  }, [location.pathname, location.search, location.hash, trackPageView]);

  return null;
};
